export default __webpack_public_path__ + "static/media/icon-insights-performance-delivery.d91947a2.svg";